import React from "react";
import { HelixIcon } from '@lwt-helix/helix-icon';
import { wolfie } from '@lwt-helix/helix-icon/outlined';
import { Button } from "@lwt-helix/buttons";
import Tooltip from "@lwt-helix/tooltip";
import { loginTerms as lt} from "../../constants";
import { navigateToAuth, navigateToPlatformUI } from "../../constants/nav";
import { useAuthStore } from "../../store/auth/store";
import { Routes } from "../../common/routes/routes";
import { isDev, isLocal } from "../../providers/endpoint.provider";
import { useCommonStore } from "../../store/store";

const SignInLWAButton = () => {
    const {
        isLoading,
    } = useAuthStore(({ isLoadingByRoute }) => ({
        isLoading: isLoadingByRoute[Routes.AUTH.LOG_IN],
    }));

    const isAuthLoading = useCommonStore(state => state.isLoading);

    const handleSignInClick = (e) => {
        useCommonStore.setState({isLoading: true});
        if (isLoading) return;

        e.preventDefault();
        useAuthStore.setState({authError: undefined});
        // We use this locally while pointing to stage or pre to make it easier to login with platform since those environments doesn't allow to redirect to a custom URL like dev does.
        if(isLocal && !isDev) {
            navigateToAuth();
            return;
        }
        navigateToPlatformUI();
    };

    return (
        <>
            <Button
                id='lwa-sign-in-btn'
                dataLwtId='lwa-sign-in-btn'
                onClick={handleSignInClick}
                className={`sign-lwa d-flex justify-content-center align-items-center mt-4 p-0`}
                color="text"
                disabled={isLoading || isAuthLoading}
            >
                <HelixIcon icon={wolfie} className='wolfie-icon mr-2' />
                {lt.signInLWA}
            </Button>
            <Tooltip id='lwa-tooltip' target='lwa-sign-in-btn' placement='bottom'>
                {lt.lwaTooltip}
            </Tooltip>
        </>
    );
};

export default SignInLWAButton;
